import React from 'react';
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Modal,
  Row,
} from 'reactstrap';
import ReactDatetime from 'react-datetime';
import moment from 'moment';

interface RaiseModalProps {
  isOpen: boolean;
  toggle: () => void;
  employees: any[];
  raiseStaff: string;
  setRaiseStaff: (value: string) => void;
  raiseReason: string;
  setRaiseReason: (value: string) => void;
  raiseCurrentAmount: string;
  raiseAmount: string;
  setRaiseAmount: (value: string) => void;
  raiseDateItBecomesEffectiveOn: string;
  setRaiseDateItBecomesEffectiveOn: (value: string) => void;
  raiseFileSelected: File | null | undefined;
  setRaiseFileSelected: (file: File | null) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  handleRaiseFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCustomButtonClick: () => void;
  handleSubmitRaise: (event: React.FormEvent) => Promise<void>;
}

const RaiseModal = ({
  isOpen,
  toggle,
  employees,
  raiseStaff,
  setRaiseStaff,
  raiseReason,
  setRaiseReason,
  raiseCurrentAmount,
  raiseAmount,
  setRaiseAmount,
  raiseDateItBecomesEffectiveOn,
  setRaiseDateItBecomesEffectiveOn,
  raiseFileSelected,
  setRaiseFileSelected,
  fileInputRef,
  handleRaiseFileChange,
  handleCustomButtonClick,
  handleSubmitRaise,
}: RaiseModalProps) => {
  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen} toggle={toggle} size={'xl'}>
      <div className="modal-header">
        <h4 className="modal-title">Request a Raise</h4>
        <div onClick={toggle} className="d-flex p-1 cursor-pointer">
          <i className="fas fa-times" />
        </div>
      </div>
      <div className="modal-body">
        <div className="px-2">
          <Form onSubmit={handleSubmitRaise}>
            <Row>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Name</label>
                  <Input type="select" value={raiseStaff} required onChange={(e) => setRaiseStaff(e.target.value)}>
                    <option value=""></option>
                    {employees?.map((value: any, index: number) => {
                      return (
                        <option value={value.user.id} key={`codes-${index}`}>
                          {value.user.firstName} {value.user.lastName}
                        </option>
                      );
                    })}
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="6">
                <FormGroup>
                  <label className="form-control-label">Reason</label>
                  <Input type="select" value={raiseReason} required onChange={(e) => setRaiseReason(e.target.value)}>
                    <option value=""></option>
                    <option value="Degree">Degree</option>
                    <option value="CDA">CDA</option>
                    <option value="Annual">Annual</option>
                    <option value="Position Change">Position Change</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col lg="4">
                <label className="form-control-label">$ Current Rate</label>
                <Input type="text" value={raiseCurrentAmount} disabled />
              </Col>

              <Col lg="4">
                <label className="form-control-label">$ Amount</label>
                <Input
                  type="text"
                  value={raiseAmount}
                  required
                  onChange={(event) => {
                    const numbers = event.target.value.replace(/[^\d]/g, '');
                    const amount = (parseFloat(numbers) / 100).toLocaleString('en-IN', {
                      style: 'currency',
                      currency: 'USD',
                    });
                    setRaiseAmount(String(amount).replaceAll(',', ''));
                  }}
                />
              </Col>

              <Col lg="4">
                <FormGroup>
                  <label className="form-control-label">Date It Becomes Effective On</label>
                  <InputGroup className="input-group-alternative">
                    <ReactDatetime
                      inputProps={{
                        placeholder: 'Start Date',
                      }}
                      onChange={(newValue) => {
                        setRaiseDateItBecomesEffectiveOn(`${newValue}`);
                      }}
                      timeFormat={false}
                      value={`${moment(raiseDateItBecomesEffectiveOn).format('MM/DD/yyyy')}`}
                      dateFormat={'MM/DD/yyyy'}
                      closeOnSelect={true}
                    />
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="ni ni-calendar-grid-58" />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>

            <div className="mt-4">
              <h3>Attach File Here</h3>
              <div className="d-flex align-items-center">
                <Button color="primary" onClick={handleCustomButtonClick} style={{ width: 170 }}>
                  Select File
                </Button>
                <input ref={fileInputRef} type="file" style={{ display: 'none' }} onChange={handleRaiseFileChange} />
                {raiseFileSelected && (
                  <>
                    <p className="p-0 m-0">Selected Document: {raiseFileSelected.name} </p>
                    <div onClick={() => setRaiseFileSelected(null)} className="d-flex p-1 cursor-pointer ml-2">
                      <i className="fas fa-times" />
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="d-flex justify-content-around mt-4">
              <Button className="btn-secondary" onClick={toggle}>
                Cancel
              </Button>
              <Button style={{ background: '#02c412', color: '#FFFFFF', width: '150px' }}>Save</Button>
            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default RaiseModal;
